import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-testimonial-success',
  templateUrl: './testimonial-success.component.html',
  styleUrls: ['./testimonial-success.component.scss']
})
export class TestimonialSuccessComponent implements OnInit {

 constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
  }

}
